export default __webpack_public_path__ + "static/bg-purple-card-10bf059eb157128d827e16d0edb58591.png";